<template>
    <div id="app">
        <!-- 菜单导航 -->
        <Nav v-bind="{'type':'2','active':active}"/>
        <!-- 内容 -->
        <div class="News-wrapper">
          <div class="News-nav" v-if="active == '2'">
            <span>当前位置：政策法规 > </span>
            <span>法规详情</span>
          </div>
          <div class="News-nav" v-if="active == '3'">
            <span>当前位置：行业新闻 > </span>
            <span>新闻详情</span>
          </div>
          <div class="News-nav" v-if="active == '4'">
            <span>当前位置：通知公告 > </span>
            <span>公告详情</span>
          </div>
          <div class="News-content">
            <div class="News-content-title">
              <h1>{{ContentInfo.contentTitle}}</h1>
              <p>
                <span>来源：{{ContentInfo.contentSource}}</span>
                <span>时间：{{ContentInfo.modifyTime | datefilter}}</span>
                <span>浏览：{{ContentInfo.contentHit}}</span>
              </p>
            </div>
            <div v-html="ContentInfo.contentDetails" class="contentDetails"></div>
          </div>
        </div>
        <!-- 功能块 -->
        <FunctionBlock />
        <Footer />
      </div>
</template>
<script>
import "./index.scss";
import Nav from "@/components/newsComponents/NavMenu/index.vue";
import Footer from "@/components/newsComponents/footer/index.vue";
import FunctionBlock from "@/components/newsComponents/functionBlock/index.vue";
export default {
    name: "App",
    components: {
        Nav,
        Footer,
        FunctionBlock,
    },
    data() {
        return {
            id: "", //主键
            active: "", //导航激活页面
            ContentInfo: {
                modifyTime: 1585625178000,
            },
        };
    },
    filters: {
        datefilter: function (val) {
            var date = new Date(val);
            var y = date.getFullYear();
            var m = date.getMonth() + 1;
            m = m < 10 ? "0" + m : m;
            var d = date.getDate();
            d = d < 10 ? "0" + d : d;
            return y + "-" + m + "-" + d;
        },
    },
    created() {
        // if(this.getQueryVariable('active')){
        //   this.active = this.getQueryVariable('active');
        // }
        this.id = this.getQueryVariable("id");

        this.getData(); //数据
        this.addHit(); //增加浏览量
        console.log(this.datefilter);
        let pageName = ''
        if(this.active == 2){
            pageName = '法规详情'
        }else if(this.active == 3){
            pageName = '新闻详情'
        }else if(this.active == 4){
            pageName = '公告详情'
        }

        this.$api.visitLog({webServerType:0,pageName:pageName})
    },
    methods: {
        getData: function () {
            this.$api
                .queryContentInfo({ id: this.id })
                .then((res) => {
                    console.log(res);
                    if (res.data.resultCode == 200) {
                        this.ContentInfo = res.data.ContentInfo;
                        console.log(this.ContentInfo)
                        switch (this.ContentInfo.contentCategoryId) {
                            case "152":
                                this.active = "2";
                                break;
                            case "153":
                                this.active = "3";
                                break;
                            case "154":
                                this.active = "4";
                                break;
                        }
                    } else {
                        this.$message.error({ title: res.data.resultDesc });
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        addHit() {
            this.$api
                .addContentHit({ id: this.id })
                .then((res) => {
                    console.log(res);
                })
                .catch((err) => {
                    console.log(err);
                });
        },
    },
};
</script>
